import createReducer from 'shared/utils/createReducer';
import { LOGOUT } from 'modules/auth/actions/logout';
import { FETCH_ORGANIZATION_CONFIG } from 'modules/common/actions/fetchOrganizationConfig';
import requestsStatuses from '../constants/requestsStatuses';


const defaultState = {
  requestStatus: requestsStatuses.default,
  appointmentConfig: {},
  generalConfig: {},
  defaultPhoneCountryCode: null,
};

export default createReducer(defaultState, {
  [FETCH_ORGANIZATION_CONFIG.pending]: state => ({
    ...state,
    requestStatus: requestsStatuses.pending,
  }),

  [FETCH_ORGANIZATION_CONFIG.success]: (state, { payload: { appointmentConfig, generalConfig, defaultPhoneCountryCode } }) => ({
    ...state,
    requestStatus: requestsStatuses.success,
    appointmentConfig,
    generalConfig,
    defaultPhoneCountryCode,
  }),

  [FETCH_ORGANIZATION_CONFIG.failure]: state => ({
    ...state,
    requestStatus: requestsStatuses.failure,
  }),

  [LOGOUT.failure]: () => defaultState,
  [LOGOUT.success]: () => defaultState,
});
